export default __webpack_public_path__ + "images/logo-footer.a5112e2061ff5c9b42f89522cfac50fd.png";